import { Container } from 'react-bootstrap';
import getImageLogosSrcSet from '../helper/ImageKit';
import { GeoAltFill, EnvelopeAt } from 'react-bootstrap-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <Container className="footer-container">
        <img
          src="https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-1200,f-auto,q-80"
          srcSet="
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-200 400w,
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-400 800w,
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-800 1200w,
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-1920,h-1350 1920w,
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-2560 2560w,
            https://ik.imagekit.io/wwg4nuz3a/logos/jci-new-logo.png?tr=w-3840 3840w
          "
        sizes="100vw"
        />
        <div className='footer-content'>
          <div className='footer-quicklinks'>
            <h3>Quick Links:</h3>
            <ul>
              <li ><a href="/about-us">About Us</a></li>
              <li ><a href="/our-publication">The Clarion</a></li>
              <li ><a href="/projects">Projects</a></li>
              <li ><a href="/contact-us">Contact Us</a></li>
            </ul>
          </div>
          <div className='footer-contact-us'>
            <h3>Contact Us:</h3>
            <div >
              <EnvelopeAt size={30} color='white'/>
              <p>jcilucenajaycees<br/>@gmail.com</p>
            </div>
          </div>
          <div className='footer-our-location'>
            <h3>Location:</h3>
            <div>
              <GeoAltFill size={30} color='red'/>
              <p>Lucena City,<br/>Quezon Province</p>
            </div>
          </div>
        </div>
      </Container>
      <div className='footer-copyright'>
        <small>© {new Date().getFullYear()} JCI Lucena Philippines. All rights reserved.</small>
      </div>
    </footer>
  );
}

export default Footer;
